import React, { PureComponent } from "react";
import { IReducerState } from "../../../../states/renditionStates";
import * as asyncStateAction from '../../../../actions/asyncStateAction';
import { connect } from "react-redux";
import serviceConfig from "../../../../services/servicesConfig";
import _ from 'lodash';
import DomTemplate from '../../../../mainpage/domTemplate';

interface IEconomicCalendarContentFunctionalProps {
    loadEconomicCalendarData: () => {};
}

interface IEconomicCalendarContentVariableProps {
    economicCalendarData: any;
}

interface IEconomicCalendarContentProps extends IEconomicCalendarContentFunctionalProps, IEconomicCalendarContentVariableProps {
}

export class EconomicCalendarContent extends PureComponent<IEconomicCalendarContentProps, any> {

    constructor(props: IEconomicCalendarContentProps) {
        super(props);
        this.props.loadEconomicCalendarData();
    }

    public render() {
        const { economicCalendarData } = this.props;
        return (<div style={{'padding': '2px'}}>{economicCalendarData.EconomicDataCalendar?.map((currentValue: any) => {
            return (
                <DomTemplate sourceM={currentValue} dataStringM={currentValue.class} classNameM={''} />
            );
        })}</div>);
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        economicCalendarData: state.asyncStateReducer.economicCalendarData,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loadEconomicCalendarData: () => dispatch(asyncStateAction.fetchEconomicCalendarData(serviceConfig.GET_ECONOMIC_CALENDAR_JSON_DATA))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EconomicCalendarContent);
